import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import DisplayLocation from '../../common/googlemap/DisplayLocation';

const useStyles = makeStyles((theme) => ({
    locationContainer: {
        display: 'flex',
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
        },
    },
    locationMap: {
        flexGrow: 1,
        margin: theme.spacing(1),
        maxWidth: '60rem',
        minWidth: '26rem',
        height: '30rem',
    },
    addressContainer: {
        display: 'flex',
        alignItems: 'center',
        margin: theme.spacing(1),
    },
    locationIcon: {
        color: '#ff3860', // Matching the original red color
        fontSize: '1.8rem',
        marginRight: theme.spacing(1),
    },
    addressText: {
        fontSize: '1.6rem',
        color: theme.palette.text.primary,
    },
}));

const JobDetailLocation = ({ address, jobLocation }) => {
    const classes = useStyles();

    const renderLocation = () => {
        if (!jobLocation) return null;

        return (
            <DisplayLocation
                className={classes.locationMap}
                location={{
                    lat: jobLocation.coordinates[1],
                    lng: jobLocation.coordinates[0],
                }} />
        )
    }

    return (
        <Box className={classes.locationContainer}>
            {renderLocation()}
            <Box className={classes.addressContainer}>
                <LocationOnIcon className={classes.locationIcon} />
                <Typography className={classes.addressText}>
                    {address}
                </Typography>
            </Box>
        </Box>
    )
}

JobDetailLocation.propTypes = {
    address: PropTypes.string,
    jobLocation: PropTypes.object
}

export default JobDetailLocation
